import { useEffect, useRef, useState } from "react";
import AvatarEditor from "react-avatar-editor";
import { Box, Button, CircularProgress, Modal, Slider } from "@mui/material";
import "./CropperModal.scss";  // Make sure this file contains necessary styles
import { useTMutation } from "../../utils/useTMutation";
import showToast from "../Hot-Toast/showToast";
import PropTypes from 'prop-types';
import { setUserDetails } from "../../slice/userSlice";
import { useDispatch, useSelector } from "react-redux";


const boxStyle = {
    width: "300px",
    height: "300px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: 'relative', // Make sure Box is positioned relative for absolute positioning inside
};

const modalStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};


const CropperModal = ({ src, modalOpen, setModalOpen, setPreview, handleCancel, propsData, onChange }) => {


    const currentUserDetails = useSelector((state) => state.user.userDetails);
    const dispatch = useDispatch();
    const [slideValue, setSlideValue] = useState(10);
    const cropRef = useRef(null);
    console.log("src", src)
    console.log("modalOpen", modalOpen)
    console.log("cropRef", cropRef)

    console.log("postdata", propsData)
    console.log("setPreview", setPreview)
    useEffect(() => {
        if (modalOpen) {
            setSlideValue(10); // Reset scale to default
        }
    }, [modalOpen]);
    const mutation = useTMutation("/uploadprofileImage", "post", (data) => {
        if (data.STATUS) {
            return data;
        } else {
            showToast("error", data.MESSAGE, 3000);
        }
    });
    const handleSave = async () => {
        if (cropRef.current) {
            try {
                if (propsData.directory === "profileImage") {
                    const dataUrl = cropRef.current.getImage().toDataURL();
                    const result = await fetch(dataUrl);
                    const blob = await result.blob();
                    const formData = new FormData();
                    formData.append('file', blob, `profilePicture.png`); // Adjust filename as needed
                    if (typeof onChange === "function") {
                        onChange(blob)
                        setPreview(URL.createObjectURL(blob));
                        setModalOpen(false);
                        return
                    }
                    formData.append('USER_TYPE', propsData?.USER_TYPE);
                    formData.append('USER_ID', propsData?.ID);
                    formData.append('COVER_IMG', propsData?.directory);
                    const response = await mutation.mutateAsync(formData);
                    if (response.STATUS) {
                        console.log("zsdgfsdgsdfg", response)
                        setPreview(URL.createObjectURL(blob));
                        const updatedUserDetails = {
                            ...currentUserDetails,
                            PROFILE_IMAGE_PATH: response.OUTPUT
                        };
                        dispatch(setUserDetails(updatedUserDetails));

                        setModalOpen(false);
                    } else {
                        showToast("error", response.MESSAGE, 3000);
                    }
                }
                else {
                    const dataUrl = cropRef.current.getImage().toDataURL();
                    const result = await fetch(dataUrl);
                    const blob = await result.blob();
                    const formData = new FormData();
                    formData.append('file', blob, `profilePicture.png`); // Adjust filename as needed
                    if (typeof onChange === "function") {
                        onChange(blob)
                        setPreview(URL.createObjectURL(blob));
                        setModalOpen(false);
                        return
                    }
                    formData.append('USER_TYPE', propsData?.USER_TYPE);
                    formData.append('USER_ID', propsData?.ID);
                    formData.append('COVER_IMG', propsData?.directory);
                    const response = await mutation.mutateAsync(formData);
                    if (response.STATUS) {
                        setPreview(URL.createObjectURL(blob));
                        console.log("zsdgfsdgsdfg", response)
                        const updatedUserDetails = {
                            ...currentUserDetails,
                            PROFILE_COVER_IMAGE_PATH: response.OUTPUT
                        };
                        dispatch(setUserDetails(updatedUserDetails));

                        setModalOpen(false);
                    } else {
                        showToast("error", response.MESSAGE, 3000);
                    }
                }
            } catch (error) {
                console.error('Error uploading file:', error);
            }
        }
    };

    const handleBackdropClick = (event) => {
        event.stopPropagation(); // Prevent backdrop click from closing modal
    };

    return (
        <Modal
            sx={modalStyle}
            open={modalOpen}
            onClose={handleCancel} // Close modal when clicking outside the content area
            disableScrollLock
            onClick={handleBackdropClick} // Prevent backdrop click from closing modal
        >
            <Box
                sx={boxStyle}
                onClick={(e) => e.stopPropagation()} // Prevent click inside Box from closing modal
            >
                <AvatarEditor
                    ref={cropRef}
                    image={src}
                    borderRadius={propsData.directory === "profileImage" ? 150 : 0}
                    color={[0, 0, 0, 0.72]}
                    scale={slideValue / 10}
                    className="cropper-editor"
                    sx={{
                        position: "absolute",
                        top: 125,
                        left: 15,
                        width: 120,
                        height: 120,
                        // border: "4px solid black",
                    }}
                />

                <Slider
                    min={10}
                    max={50}
                    sx={{
                        margin: "0 auto",
                        width: "80%",
                        color: "cyan",
                    }}
                    size="medium"
                    defaultValue={slideValue}
                    value={slideValue}
                    onChange={(e) => setSlideValue(e.target.value)}
                />
                <Box
                    sx={{
                        display: "flex",
                        padding: "10px",
                        border: "2px solid white",
                        background: "black",
                    }}
                >
                    <Button className="custombutton"
                        size="small"
                        sx={{ marginRight: "10px", color: "white", borderColor: "white" }}
                        variant="outlined"
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>
                    <Button className="custombutton"
                        sx={{ background: "#5596e6" }}
                        size="small"
                        variant="contained"
                        onClick={handleSave}
                        disabled={mutation?.isPending}
                    >
                        {mutation?.isPending ? <CircularProgress size={24} /> : "Save"}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};
CropperModal.propTypes = {
    src: PropTypes.string.isRequired,
    modalOpen: PropTypes.bool.isRequired,
    setModalOpen: PropTypes.func.isRequired,
    setPreview: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    propsData: PropTypes.shape({
        directory: PropTypes.string.isRequired,
        ID: PropTypes.string.isRequired
    }).isRequired
};

export default CropperModal;
